<template>
  <v-card :ref="'refDeviceStatus' + item.sn" :style="canBeEdit || isInEditMode ? '' : 'opacity: 0.3;'" justify="start" class="ma-0 pa-0" outlined elevation="3" style="max-width: 1100px" :height="editDeviceItemHeight - 8">
    <v-card-title class="ma-1 pa-0" align="left">
      <v-row class="ma-0 pa-0 pl-3 pt-1" justify="start" align="center">
        <v-col v-if="item.Status" sm="3" md="5" xl="5" cols="3" class="ma-0 pa-0">
          <v-badge avatar overlap left color="transparent">
            <template v-slot:badge>
              <v-avatar>
                <v-icon small :color="item.Status.Color">{{ item.Status.Icon }}</v-icon>
              </v-avatar>
            </template>
            <v-avatar size="40" tile>
              <v-img :src="item.Image" width="auto" height="auto" contain></v-img>
            </v-avatar>
          </v-badge>
          <span v-if="!isOnMobile" class="subtitle-2 ml-2">
            {{ TR.Status + ":" }}
            <span class="subtitle-2" :style="`color: ${item.Status.Color}`">{{ item.Status.Text }}</span>
          </span>
        </v-col>
        <v-col sm="9" md="7" xl="7" cols="9" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 box-container-horizontal" align="center" justify="center">
            <div class="ma-0 pa-0 row-content" style="overflow: hidden">
              <span v-if="!isInEditMode" class="subtitle-1" style="white-space: no">{{ item.Name }}</span>
              <div v-else class="ma-0 pa-0">
                <v-text-field class="ma-0 pa-0" :placeholder="item.Name" clearable v-model="item.Name" dense single-line clear-icon="mdi-close-circle-outline" hide-details></v-text-field>
                <t-divider></t-divider>
              </div>
            </div>
            <div class="ma-0 pa-0 row-header">
              <v-btn v-if="isInEditMode" class="ma-2 pa-0" small icon @click="saveDevInfo(item)">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-check</v-icon>
                  </template>
                  <span>{{ TR.SaveChanges }}</span>
                </v-tooltip>
              </v-btn>
              <v-btn v-else-if="canBeEdit" class="ma-2 pa-0" small icon @click="setEditMode(true)">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">mdi-pencil</v-icon>
                  </template>
                  <span>{{ TR.EditInfo }}</span>
                </v-tooltip>
              </v-btn>
            </div>
          </v-row>
        </v-col>
        <v-col class="ma-0 pa-0"></v-col>
      </v-row>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="text-align: left" class="ma-0 pa-2">
      <v-row class="ma-0 pa-0">
        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.DevNumber }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span class="text-no-wrap">{{ item.sn }}</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Model }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span style="cursor: pointer; text-decoration: underline">{{ item.model.name }}</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Activity }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <span v-if="item.featureAccess && item.lastTalkDate">{{ new Date(item.lastTalkDate).toTremolFpString() }}</span>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 34px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Address }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8">
              <div class="box-container-horizontal">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" v-if="!isInEditMode" class="text-no-wrap row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" style="cursor: pointer; text-decoration: underline" @click="showModalMap(item.Address)">
                      <v-icon small left>mdi-map-marker-radius-outline</v-icon>
                      {{ item.Address }}
                    </span>
                  </template>
                  <span>{{ item.Address }}</span>
                </v-tooltip>
                <div class="row-content ma-0 pa-0" v-if="isInEditMode">
                  <v-text-field class="ma-0 pa-0" v-model="item.Address" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.Address" hide-details dense single-line></v-text-field>
                  <t-divider></t-divider>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>

        <v-col cols="12" sm="12" md="6" lg="6" xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ isOnMobile ? TR.PSN : TR.PSName }}</span>
            </v-col>
            <v-col class="ma-0 pa-0" cols="8" justify="space-between">
              <div class="box-container-horizontal ma-0 pa-0">
                <v-tooltip :disabled="hideTooltips" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on" v-if="!isInEditMode" class="text-no-wrap subtitle-1 row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.PSName }}</span>
                  </template>
                  <span>{{ item.PSName }}</span>
                </v-tooltip>
                <div class="row-content ma-0 pa-0" v-if="isInEditMode">
                  <v-text-field class="ma-0 pa-0" v-model="item.PSName" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.PSName" hide-details dense single-line></v-text-field>
                  <t-divider></t-divider>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>
        <v-col cols="12" sm="12" :md="6" :lg="6" :xl="5" xs="12" class="ma-0 pa-0">
          <v-row class="ma-0 pa-0 px-1" justify="center" align="center" style="height: 36px">
            <v-col class="ma-0 pa-0" cols="4">
              <span class="text-no-wrap">{{ TR.Technician }}</span>
            </v-col>
            <v-col cols="8" class="ma-0 pa-0" justify="space-between">
              <div class="box-container-horizontal">
                <v-tooltip top v-if="item.Technician">
                  <template v-slot:activator="{ on }">
                    <span v-on="on" v-if="!isInEditMode" class="text-no-wrap subtitle-1 row-content" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'">{{ item.Technician.n }}</span>
                  </template>
                  <span style="white-space: pre-line">{{ item.Technician.n + "\n" + item.Technician.p + "\n" + item.Technician.c }}</span>
                </v-tooltip>
                <div v-if="isInEditMode" class="row-content ma-0 pa-0">
                  <v-select
                    clearable
                    clear-icon="mdi-close"
                    class="ma-0 pa-0"
                    style="overflow: hidden"
                    :items="techs"
                    return-object
                    v-model="item.Technician"
                    item-text="name"
                    no-data-text="Не са добавени лица за поддръжка"
                    dense
                    single-line
                    hide-details
                  ></v-select>
                  <!-- <v-text-field class="ma-0 pa-0" v-model="item.Comment" :style="isOnMobile ? 'scrollbar-width: thin;' : 'overflow: hidden;'" :placeholder="item.Comment" dense single-line hide-details></v-text-field> -->
                  <t-divider></t-divider>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-divider class="mr-1"></v-divider>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import DataManager, { ErrorMessage } from "../../js/DataManager";
import bus, { TR } from "../../main";

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    device: {
      type: Object,
    },
    technicians: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      item: this.device,
      techs: this.technicians,
      isInEditMode: this.editMode,
      canBeEdit: true,
      TR: TR,
    };
  },
  methods: {
    showModalMap(devaddress, maplatlng) {
      if (devaddress)
        this.dialog.show("google-map", null, {
          //this.$modal.show("modal-map", {
          address: devaddress,
          latlng: maplatlng,
        });
    },
    saveDevInfo(item) {
      DataManager.updateDevNameAndSettingsGlobal(item.sn, item.Name, item.settings1, (err) => {
        if (err.ErrorCode == ErrorMessage.ERROR_CODE_OK) {
          this.dialogLoader.hide();
          this.setEditMode(false);
          this.dialogLoader.showInfo(TR.SaveSuccessful);
          if (this.editMode) {
            this.dialog.close();
          }
        } else {
          var msg = err.Message + "\n";
          if (err.ErrorDetails) {
            err.ErrorDetails.forEach((d) => (msg += d.Description + "\n"));
          }
          this.dialogLoader.showError(msg);
        }
      });
    },
    setEditMode(newVal) {
      this.isInEditMode = newVal;
      if (newVal) {
        bus.$emit(bus.EVENT_Device_started_to_edit, DataManager.getData(DataManager.DataType.devices).indexOf(this.device));
      } else {
        bus.$emit(bus.EVENT_Device_started_to_edit, -1);
      }
    },
  },
  created() {
    if (this.techs == null) {
      this.techs = DataManager.getData(DataManager.DataType.user, true).settings2.technicians;
    }
  },
  mounted() {
    bus.$on(bus.EVENT_Device_started_to_edit, (idx) => {
      this.canBeEdit = idx == -1;
    });
    bus.$on(bus.EVENT_Device_selected_for_subscribtion, (dev) => {
      this.selectDeviceForSubscription(dev);
    });
  },
};
</script>

<style>
</style>
